import React from 'react';
import { Button } from '../components/ui/button';
import { Plus } from 'lucide-react';
import Sidebar from '../components/layout/sidebar';
import MobileSidebar from '../components/layout/mobile-sidebar';
import TopNav from '../components/layout/top-nav';

export default function EventsPage() {
  return (
    <div className="remodra-layout">
      <div className="hidden md:block"><Sidebar /></div>
      <MobileSidebar />
      <div className="remodra-main-mobile md:ml-64">
        <TopNav />
        <div className="remodra-content">
          <main className="dashboard-2025 bg-[var(--dash-bg)] min-h-screen p-6 md:p-8 pt-24 flex flex-col items-center">
            <div className="w-full space-y-6">
              <div>
                <h1 className="text-2xl font-bold text-[var(--dash-text)]">Events</h1>
                <p className="text-sm text-[var(--dash-text-muted)] mt-0.5">Manage your events and appointments.</p>
              </div>
              <div className="rounded-xl border border-[var(--dash-border)] bg-[var(--dash-card)] shadow-[var(--dash-shadow)] overflow-hidden">
                <div className="px-6 py-4 border-b border-[var(--dash-border)]">
                  <h2 className="text-lg font-semibold text-[var(--dash-text)]">Events Management</h2>
                </div>
                <div className="p-8 text-center">
                  <p className="text-[var(--dash-text-muted)] mb-4">Events functionality coming soon.</p>
                  <Button className="bg-[var(--dash-accent)] hover:opacity-90 text-white">
                    <Plus className="h-4 w-4 mr-2" />
                    Create Event
                  </Button>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
} 